fragment ArticlePreviewFragment on article_Entry {
  title
  slug
  uri
  readTime
  teaserText
  image {
    url
    title
  }
  topics(limit: 1) {
    title
    slug
    uri
    id
  }
  categories: knowledgeCategories(limit: 1) {
    title
    slug
    id
  }
  expert {
    title
    slug
    ... on expert_Entry {
      image {
        url
      }
    }
  }
}
